import React from 'react';

const LimitButton = ({
  currentLimit,
  changeLimit,
}) => {
  return (
    <div className='page-limit'>
      <select
        value={currentLimit}
        onChange={e => changeLimit(e.target.value)}
      >
        <option value={10}>10</option>
        <option value={20}>20</option>
        <option value={50}>50</option>
        <option value={100}>100</option>
        <option value={200}>200</option>
        <option value={500}>500</option>
      </select>
    </div>
  );
};

export default LimitButton;